<template>
  <v-container fluid class="pa-0 ma-0">

    <v-row dense justify="center">
        <v-col >

          <v-menu 
            v-model="dialog_com"
            :close-on-content-click="false"
            offset-x left
            min-width="290px"
             @input="menu_handler"
            >
            <template v-slot:activator="{ on: menuOn }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltipOn, attrs }">
                <div v-on="Object.assign({}, menuOn, tooltipOn)" v-bind="attrs" style="cursor:pointer" class="d-flex flex-column">
                  <div style="width:25px;height:12px;font-size:10px;text-align:center">PC</div>
                  <div style="width:25px;height:12px;font-size:10px;text-align:center">
                    {{ size }}
                  </div>
                </div>
                </template>
                <span>{{ $t('pagetip_col1') }}</span>
              </v-tooltip>
            </template>
  
            <v-card class="ma-0 pa-1">
              <v-row dense align="center" class="pa-0 ma-0">
                <v-col cols="9" class="ml-5 mt-2">
                  <label style="color:black">{{title}}</label>
                </v-col>
                <v-col cols="2" class="mt-2">
                  <v-btn icon small class="dialog_close_btn mr-1" @click="close_com"><v-icon>mdi-close</v-icon></v-btn>
                </v-col>
              </v-row>
  
              <v-row dense justify="center" class="pa-0 ma-0">
                <v-col cols="11">
                  <div style="background:gray;height:1px;" />
                </v-col>
              </v-row>
  
              <v-card-text>
                <v-container>
                  <v-row justify="center">
                    <v-col cols="6" class="pa-0 ma-0" align="center">
                      <input 
                        v-model="bgsize" 
                        style="width:70px;font-size:12px;border: solid 1px gray;border-radius:3px;text-align:center;"
                        />
                    </v-col>
                    <v-col cols="11" class="pa-0 ma-0">
                      <v-slider
                          v-model="bgsize"
                          color="blue"
                          :min="min"
                          :max="max"
                          :step="step"
                          track-color="blue"
                          thumb-color="purple"
                          :thumb-size="10"
                          hide-details
                          style="min-height:20px"
                          />
                  </v-col>
                  </v-row>
                </v-container>
              </v-card-text> 
  
              <v-row dense justify="center" class="pa-0 ma-0">
                <v-col cols="11">
                  <div style="background:gray;height:1px;" />
                </v-col>
              </v-row>
  
              <v-card-actions>
                <v-row justify="center">
                <v-btn variant="text" size="small" @click="close_com">{{ $t('common_cancel') }}</v-btn>
                <v-btn variant="text" size="small" class="ml-5" @click="save_com">{{ $t('common_select') }}</v-btn>
                </v-row>
              </v-card-actions>
            </v-card>
  
          </v-menu>            


        </v-col>
    </v-row>

</v-container>
</template>
  
  <script>
  export default {
  
      props:{
          obj:{type:Object, default:null},
          title:{type:String, default: ""},
          size:{type:Number, default:10},
          path:{type:String, default:""},
          min:{type:Number, default:0},
          max:{type:Number, default:200},
          step:{type:Number, default:1}
      },
  
      setup(){
  
      },
  
      mounted(){
          //console.log(this.size);
      },
  
      data: ()=> ({
          dialog_com : false,
          disabled:false,
  
          bgsize:"",
          text_backup:"",
      }),
  
  
      methods: {
  
          //다이얼로그 닫기
          close_com () {
              this.$emit('callback', this.text_backup, this.path, this.obj);
              this.dialog_com = false
          },
  
          //추가 저장
          save_com () {
              //콜백 호출 후 닫아야함.
              //this.$emit('callback');
              this.updateRender();
              this.dialog_com = false
          },      
  
          menu_handler(){
              //console.log("menu_handler");
              //최초 또는 메뉴 외곽 클릭시 
              //텍스트값 백업
              this.text_backup = this.size;
              this.bgsize = this.size;
          },
  
          //편집창 컴포넌트 렌더링
          updateRender(){
              this.$emit('callback', this.bgsize, this.path, this.obj);
          },
  
      }
  
  
  }
  </script>
  